// Approvals.js
import React, { useEffect, useState, useContext } from 'react';
import styles from './Admin.module.css';
import { Outlet } from 'react-router-dom';
import Topbar from '../../Components/Topbar/Topbar';
import { useMsal } from "@azure/msal-react";
import AdminContext from '../../Context/adminContext';

// TopbarData.js
export const initialTopbarData = [
  {
    title: 'Leave',
    link: '/Admin/Leave',
    disabled: false,
  },
  {
    title: 'Sickness',
    link: '/Admin/Sickness',
    disabled: false,
  },
  {
    title: 'Users',
    link: '/Admin/Users',
    disabled: false,
  },
  {
    title: 'Discrepancies',
    link: '/Admin/Discrepancies',
    disabled: false,
  },
  {
    title: 'Settings',
    link: '/Admin/Settings',
    disabled: false,
  },
  // Add more top bar items
];

function Admin() {
  const [TopbarData, setTopbarData] = useState(initialTopbarData);

  const { instance, accounts } = useMsal();
  const API_URL = process.env.REACT_APP_API_URL;
  const account = accounts[0];
  const isAdmin = useContext(AdminContext);

  return (
    <div className={styles.profileContainer}>
      <Topbar TopbarData={TopbarData} />
      <Outlet />
    </div>
  );
}

export default Admin;
